import Service from '../helpers/service';
import { fetchTransaction, editTransaction, destroyTransaction } from "../actions/transaction_action";
import { fetchTransactionMeta, editTransactionMeta } from "../actions/transaction_meta_action";
import Helping from "../helpers/Helping";
import { API_URL } from "../config/urls";
import { GET_TRANSACTIONS } from '../config/routes';
import { trackPromise } from 'react-promise-tracker';

let updateCallback = (res) => {
}

export const setTransactionError = (callback) => {

  updateCallback = callback;

}

export const getAll = (page, limit, sorting, sort_type, buyerName, payment_type, status, type, blockchain, startDate, endDate, nft_code = "") => {
  return dispatch => {
    return trackPromise(
      Service.getCall(
        API_URL.ADMIN_TRADING_API + GET_TRANSACTIONS +
        `?page=${page}&limit=${limit}&buyerName=${buyerName}&payment_type=${payment_type}&status=${status}&type=${type}&which_bc=${blockchain}&sorting=${sorting}&sort_type=${sort_type}&startDate=${Helping.formatDateInYearMonthDay(startDate)}&endDate=${Helping.formatDateInYearMonthDay(endDate)}&nft_code=${nft_code}`
      )
        .then(response => {
          let total = response.data.payload.total;

          dispatch(fetchTransaction(response.data.payload.transactions));
          dispatch(
            fetchTransactionMeta({
              page: page,
              limit: limit,
              sorting: sorting,
              sort_type: sort_type,
              total: total,
              status: status,
              type: type,
              payment_type: payment_type,
              blockchain: blockchain,
              buyerName: buyerName,
              start_date: startDate,
              end_date: endDate,
              nft_code: nft_code,
              no_Of_pages: Math.ceil(total / limit)
            })
          );
        })
        .catch(error => {
          console.log(error);
          dispatch(fetchTransaction([]));
          dispatch(
            fetchTransactionMeta({
              page: page,
              limit: limit,
              sorting: sorting,
              sort_type: sort_type,
              status: status,
              type: type,
              payment_type: payment_type,
              blockchain: blockchain,
              buyerName: buyerName,
              start_date: startDate,
              end_date: endDate,
              nft_code: nft_code,
              total: 0,
              no_Of_pages: page
            })
          );
          Helping.redirectToLogin(error);
          return updateCallback({
            ...Helping.setNetworkRequestError(error, "fetching transactions")
          })
        })
    )
  };
};

export const update = data => {
  return dispatch => {
    dispatch(editTransaction(data));
  };
};

export const updateTransactionMeta = payload => {
  return dispatch => {
    dispatch(editTransactionMeta(payload));
  };
};

export const destroy = () => {
  return dispatch => {
    dispatch(fetchTransaction([]))
    dispatch(
      fetchTransactionMeta({
        total: 0,
        isLoading: true,
        page: 1,
        limit: 10,
        sorting: 'id',
        sort_type: 'DESC',
        status: '',
        type: '',
        payment_type: '',
        blockchain: '',
        buyerName: '',
        start_date: '',
        end_date: '',
        nft_code: '',
        no_Of_pages: 1
      })
    );
  }
}

